import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
// Components
import { LCAlert } from '../../../components/alert';
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import EnhancedForm from '../../../components/form';
import { FormDatas } from '../../../local-types';
// Modules
import { PartnerById, Rule } from '../../../redux/reducers/api-types';
import { ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
import {
    actions as partnerActions,
    selectors as partnerSelectors,
    types as partnerTypes,
} from '../../../redux/reducers/partners';
import { AccountRight, RightRank } from '../../../utils/userUtils';
import { paths } from '../../paths';

interface PartnerAddProps extends WithTranslation {
    partners: PartnerById;
    paymentRules: Rule[];
    getPartnerAddError: ErrorPayload;
    savePartner: (payload: any) => void;
    isSavingPartner: boolean;
    getPaymentRules: (onSuccess?: React.EffectCallback) => void;
}

interface PartnerAddState {
    formData: any;
}

class PartnerAddPage extends React.Component<PartnerAddProps, PartnerAddState> {
    alertRef: any;

    constructor(props: PartnerAddProps) {
        super(props);
        this.state = {
            formData: {
                name: '',
                billing_period: { days: 0, weeks: 1, months: 0 },
                payment_rule: { id: 20 },
                region: { id: 1 },
            },
        };
    }

    componentDidMount() {
        const { paymentRules, getPaymentRules } = this.props;
        if (paymentRules.length === 0) {
            getPaymentRules();
        }
    }

    //========================================//
    //=============== Builders ===============//
    //========================================//

    generateInputs = (): FormDatas[] => {
        const { t /*, paymentRules*/ } = this.props;
        const inputs: FormDatas[] = [
            {
                title: t('common:form.general_infos'),
                sectionStyle: { flex: 1 },
                datas: [{ id: 'name', label: t('common:form.lastname'), required: true }],
            },
            // {
            //     title: t('billing'),
            //     subtitle: t('billing_hint'),
            //     datas: [
            //         {
            //             id: 'billing_period[days]',
            //             label: t('billing_components.day'),
            //             type: 'number',
            //         },
            //         {
            //             id: 'billing_period[weeks]',
            //             label: t('billing_components.week'),
            //             type: 'number',
            //         },
            //         {
            //             id: 'billing_period[months]',
            //             label: t('billing_components.month'),
            //             type: 'number',
            //         },
            //     ],
            // },
        ];

        // if (paymentRules) {
        //     const optionsPaymentRules: FormPickerDatas[] = [];
        //     paymentRules.forEach((p) => {
        //         optionsPaymentRules.push({ id: p.id, name: p.description });
        //     });
        //     inputs.push({
        //         title: t('paymentRules'),
        //         datas: [
        //             {
        //                 id: 'payment_rule[id]',
        //                 label: t('paymentRules'),
        //                 options: optionsPaymentRules,
        //                 noEmpty: true,
        //             },
        //         ],
        //     });
        // }

        return inputs;
    };

    onSubmitPartner = (formData: any): void => {
        const { savePartner } = this.props;
        this.setState({
            formData: formData,
        });

        const { days, weeks, months } = formData.billing_period;
        if (days === 0 && weeks === 0 && months === 0) {
            this.alertRef.showAlert();
        } else {
            this.alertRef.closeAlert();
            savePartner(formData);
        }
    };

    render() {
        const { formData } = this.state;
        const { t, getPartnerAddError, isSavingPartner } = this.props;

        return (
            <App needRights={{ name: AccountRight.PARTNER_SETTINGS, mode: RightRank.W }}>
                <ErrorMessage payload={getPartnerAddError} />
                <LCAlert onRef={(ref) => (this.alertRef = ref)} details={t('billing_hint')} type="error" open={false} />
                <EnhancedForm
                    payload={formData}
                    inputs={this.generateInputs()}
                    backRoute={paths.partners}
                    onSubmit={this.onSubmitPartner}
                    loader={isSavingPartner}
                />
            </App>
        );
    }
}

const PartnerAddPageWithTranslation = withTranslation(['partner', 'common'])(PartnerAddPage);

const mapStateToProps = (state) => ({
    partners: partnerSelectors.partners(state),
    paymentRules: partnerSelectors.paymentRules(state),
    getPartnerAddError: errorSelectors.getPartnerAddError(state),
    isSavingPartner: pendingSelectors.isPending(state, partnerTypes.SAVE_PARTNER),
});

const mapDispatchToProps = {
    savePartner: partnerActions.savePartner,
    getPaymentRules: partnerActions.getPaymentRules,
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerAddPageWithTranslation);
